import React from 'react';
import { Hourglass } from 'lucide-react';
import { cn } from '../../lib/utils';

/**
 * Semi-transparent overlay wrapper for features that are coming soon /
 * under development. Wrap any block to dim it and block interaction.
 *
 * <FeatureOverlay title="Coming Soon" subtitle="This section is under development.">
 *   <SomeSection />
 * </FeatureOverlay>
 *
 * Props:
 *  - visible:  show/hide the overlay (default true). When false, children render untouched.
 *  - title:    badge headline (default "Coming Soon")
 *  - subtitle: optional supporting text under the title
 *  - blur:     blur the wrapped content (default true)
 *  - className: extra classes for the wrapper
 */
export default function FeatureOverlay({
  visible = true,
  title = 'Coming Soon',
  subtitle = 'This feature is under development.',
  blur = false,
  className,
  children,
}) {
  if (!visible) return children;

  return (
    <div className={cn('relative', className)}>
      <div
        className={cn('pointer-events-none select-none opacity-60', blur && 'blur-[1.5px]')}
        aria-hidden="true">
        {children}
      </div>

      <div className="absolute inset-0 z-10 flex flex-col items-center justify-center rounded-xl bg-black/55 text-center p-4">
        <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary/10 border border-primary/30 mb-2">
          <Hourglass className="w-3.5 h-3.5 text-primary" />
          <span className="text-xs font-semibold uppercase tracking-wide text-primary">{title}</span>
        </div>
        {subtitle && <p className="text-xs text-muted max-w-xs leading-relaxed">{subtitle}</p>}
      </div>
    </div>
  );
}
